<template>
  <div class="contain-list">
    <div class="header-list">
      <h4>Inbox Masuk</h4>
      <p>
        <small>Total {{ infopagination?.total }} tiket</small>
      </p>
      <div class="pencarian">
        <div class="inputan">
          <i class="fa-utility fa-semibold fa-magnifying-glass"></i>
          <input type="text" name="" id="" placeholder="cari disini" v-model="searchquery" @keyup.enter="carichatfun" />
        </div>
        <div class="filter-btn">
          <button><i class="fa-regular fa-bars-filter"></i></button>
        </div>
      </div>
      <p>
        <small>Halaman {{ currentactivepage }} dari {{ maxpage }}</small>
      </p>
    </div>
    <div class="body-list">

      <h4 v-if="!istheredata">
        Sedang Ambil Data Dulu Ya
        <i class="fa-sharp-duotone fa-light fa-spinner-scale"></i>
      </h4>

      <div class="tiket-ditandai">
        <h5><i class="fa-solid fa-bookmark"></i> Tiket yang ditandai</h5>

        <ChatItemModel :status="item.status" :sender="item.getlastmessage().sender.role_id" :notiket="item.no_tiket"
          :date="fundate(item.getlastmessage().sent_at)" :msg="getmessageorfile(item.getlastmessage())"
          :namapt="item.perusahaan?.nama_perusahaan" :type="'tanda'" :isditandai="item.ditandai"
          v-for="item in tiketditandai" :key="item.id" @select="triggerbukachat(item)" />
      </div>

      <ChatItemModel :status="item.status" :sender="item.getlastmessage().sender.role_id" :notiket="item.no_tiket"
        :date="fundate(item.getlastmessage().sent_at)" :msg="getmessageorfile(item.getlastmessage())"
        :namapt="item.perusahaan?.nama_perusahaan" :isditandai="item.ditandai" :visible="item.visible" :type="'regular'"
        v-for="item in listchat.listchatdata" :key="item.id" @select="triggerbukachat(item)" />
    </div>
    <div class="footer-list">
      <button v-if="listchat.listchatdata.length <= 0">
        <i class="fa-sharp-duotone fa-solid fa-spinner-third"></i>
      </button>
      <div class="btns" v-if="listchat.listchatdata.length > 0">
        <button @click="setactivepage(1)">
          <i class="fa-sharp fa-light fa-arrow-left-to-line"></i>
        </button>
        <button @click="setactivepage(currentactivepage - 1)">
          <i class="fa-sharp fa-light fa-arrow-left"></i>
        </button>
        <button :class="n == currentactivepage ? 'active' : ''" @click="setactivepage(n)"
          v-for="n in paginatedata.visiblepage()" :key="n">
          {{ n }}
        </button>
        <button @click="setactivepage(currentactivepage + 1)">
          <i class="fa-sharp fa-light fa-arrow-right"></i>
        </button>
        <button @click="setactivepage(maxpage)">
          <i class="fa-sharp fa-light fa-arrow-right-to-line"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ChatItemModel from "@/models/ChatItemModel.vue";
import { Paginate } from "@/class/paginate";
import { getInbox, formatChatDate, generateUniqueId, datetimenow, cektiket, carichat } from "@/utils/chatcontrol";
import { Chat } from "@/class/chatobj";
import { ListChat } from "@/class/listchatobj";
import { backend, websocket } from "@/assets/config/server";
import { io } from "socket.io-client";
import { getCookie } from "@/assets/config/cookie";
import axios from "axios";
import Swal from "sweetalert2";


var globalmaxdata = 1000;

export default {
  name: "ListChat",
  data() {
    return {
      paginatedata: new Paginate(),
      currentactivepage: 1,
      perpage: 100,
      maxdata: globalmaxdata < 1 ? 1 : globalmaxdata,
      listchat: new ListChat(),
      infopagination: {},
      prevlistchat: [],
      tiketditandai: [],
      i: 0,
      websocket: websocket,
      socketio: null,
      token: "",
      //pdf.js data
      pdfDoc: null,
      pageNum: 1,
      pageCount: 0,
      scale: 1.5,
      viewerKey: 0,
      searchquery: "",
      istheredata: false,
      typebefore: 'get',
      searchquerybefore: null,
      heartbeatInterval: null,
      datauser: {

      },
      cookieall: null
    };
  },
  props: { currentTiketState: Object },
  emits: ["bukachat", "removechat"],
  components: { ChatItemModel },

  async mounted() {
    this.pdfDoc = '/pdfs/test (2).pdf'
    this.socketio = io(this.websocket, {
      transports: ["websocket"],
    });

    this.datauser = JSON.parse(getCookie('loginInfo'))

    this.terimachat();
    this.balaschat()
    //this.lockticket()

    this.heartbeatInterval = setInterval(() => {

      this.socketio.emit(
        "ticket-heartbeat",
        {
          no_tiket: this.currentTiketState.no_tiket,
          username: this.datauser.username
        },
        (res) => {

          if (!res.success) {
            console.log(res.message);

            clearInterval(this.heartbeatInterval);
          }

        }
      );

    }, 5000); // setiap 30 detik

    this.socketio.on("lockTicketResult", (result) => {
      console.log("HASIL LOCK DARI SERVER:", result);
    });
  },
  computed: {
    maxpage() {
      return Math.ceil(this.maxdata / this.perpage);
    },

    listnotiketditandai() {
      let tempnotiket = {};
      tempnotiket = this.tiketditandai.map((item) => {
        return item.no_tiket;
      });

      return tempnotiket;
    },

    allnotiket() {
      const gabungan = this.tiketditandai.concat(this.listchat.listchatdata);
      var notiket = [];
      for (const item of gabungan) {
        if (notiket.includes(item.no_tiket)) {
          continue;
        }
        notiket.push(item.no_tiket);
      }
      return notiket;
    },

    islastpage() {
      return this.maxpage == this.currentactivepage
    }
  },
  beforeMount() {
    this.cookieall = JSON.parse(getCookie("loginInfo"))
    this.token = this.cookieall.token;

    console.log(this.cookieall)
    this.prosesdata();
  },
  methods: {
    ubahpdf(item) {
      this.viewerKey++
      this.pdfDoc = encodeURI(`/pdfs/test (${item}).pdf`)
      console.log(this.pdfDoc)
    },
    lockticket() {
      this.socketio.on('lockTicket', (params) => {
        if (params.username == this.datauser.username) {
          return
        }
        console.log(params)
      })
    },
    balaschat() {
      this.socketio.on("balasMessage", (msg) => {
        //console.log("pesan balasan dari agent : ", msg)
        //console.log('user sama ? ', msg.sender.username, this.datauser.username)

        if (this.datauser.username == msg.sender.username) {
          return
        }

        const hasilcektiket = this.cektiket(msg.no_tiket)
        var currentdatatiket = null
        var idxtiket = null
        var tempsetupdata = {
          id: msg.tiket_id,
          tiket_id: msg.tiket_id,
          sender_id: 0,
          message: msg.message,
          sent_at: msg.date,
          gambar_thumb: msg.gambar_pengaduan,
          gambar: msg.gambar_pengaduan,
          file: msg.file_pengaduan,
          username: msg.sender.username,
          role_id: msg.sender.role_id,
          id_perusahaan: 0,
          user_id: 0,
          nama_perusahaan: msg.sender.username,
          senderror: false
        }

        const inputdatakelistchat = (no_tiket) => {
          idxtiket = this.listchat.listchatdata.findIndex((e) => {
            return e.no_tiket == no_tiket;
          });
          currentdatatiket = this.listchat.listchatdata[idxtiket];
          currentdatatiket.visible = true
          currentdatatiket.updatemessage(tempsetupdata)

          if (this.currentTiketState.no_tiket == no_tiket) {
            this.triggerbukachat(currentdatatiket)
          }
        }

        const inputdatakelistditandai = (no_tiket) => {
          idxtiket = this.tiketditandai.findIndex((e) => {
            return e.no_tiket == no_tiket;
          });
          currentdatatiket = this.tiketditandai[idxtiket];
          currentdatatiket.visible = true
          currentdatatiket.updatemessage(tempsetupdata)

          if (this.currentTiketState.no_tiket == no_tiket) {
            this.triggerbukachat(currentdatatiket)
          }
        }


        if (hasilcektiket.indextiket === null) {
          if (this.islastpage) {
            var wholetiket = msg.wholetiket
            wholetiket.status = 'open'
            var tempchat = new Chat(wholetiket.id, wholetiket.no_tiket, 'in_progress', wholetiket.messages, wholetiket.perusahaan, wholetiket.pengaduan)
            tempchat.updatemessage({
              id: msg.tiket_id,
              kodeunik: generateUniqueId(),
              tiket_id: msg.tiket_id,
              sender_id: null,
              message: msg.message,
              sent_at: msg.date,
              gambar_thumb: msg.gambar_pengaduan,
              gambar: msg.gambar_pengaduan,
              file: msg.file_pengaduan,
              username: msg.sender.username,
              role_id: msg.sender.role_id,
              id_perusahaan: null,
              nama_perusahaan: msg.sender.username
            })
            tempchat.visible = false
            this.listchat.insertdata(tempchat)
            // console.log(tempchat)
            // console.log(msg)
            //console.log(this.listchat.listchatdata)
          }
        } else if (hasilcektiket.indextiket !== null) {

          if (msg.no_tiket == this.currentTiketState.no_tiket) {
            if (hasilcektiket.ket == 'ditandai') {
              inputdatakelistditandai(msg.no_tiket)
            } else if (hasilcektiket.ket == 'listchat') {
              inputdatakelistchat(msg.no_tiket)
            } else if (hasilcektiket.ket == 'both') {
              inputdatakelistchat(msg.no_tiket)
              inputdatakelistditandai(msg.no_tiket)
            }

            console.log("tiket sama")
          }

          this.listchat.hidetiket(msg.no_tiket)
        }
      })
    },

    terimachat() {
      this.socketio.on("chatMessage", (msg) => {
        const hasilcektiket = this.cektiket(msg.tiket)
        var currentdatatiket = null
        var idxtiket = null
        var tempsetupdata = {
          id: msg.id,
          tiket_id: msg.id,
          sender_id: 0,
          message: msg.msg,
          sent_at: msg.dateTime,
          gambar_thumb: msg.img,
          gambar: (msg.img) ? msg.img : msg.gambar_pengaduan,
          file: (msg.file) ? msg.file : msg.file_pengaduan,
          username: msg.sender,
          role_id: 3,
          id_perusahaan: 0,
          user_id: 0,
          nama_perusahaan: msg.sender,
          senderror: false
        }

        const inputdatakelistchat = () => {
          idxtiket = this.listchat.listchatdata.findIndex((e) => {
            return e.no_tiket == msg.tiket;
          });
          currentdatatiket = this.listchat.listchatdata[idxtiket];
          currentdatatiket.visible = true
          currentdatatiket.updatemessage(tempsetupdata)
        }

        const inputdatakelistditandai = () => {
          idxtiket = this.tiketditandai.findIndex((e) => {
            return e.no_tiket == msg.tiket;
          });
          currentdatatiket = this.tiketditandai[idxtiket];
          currentdatatiket.visible = true
          currentdatatiket.updatemessage(tempsetupdata)

          if (this.currentTiketState.no_tiket == msg.tiket) {
            this.triggerbukachat(currentdatatiket)
          }
        }

        if (hasilcektiket.indextiket === null) {
          if (this.islastpage) {
            var wholetiket = msg.wholetiket
            wholetiket.status = 'open'
            var tempchat = new Chat(wholetiket.id, wholetiket.no_tiket, 'open', wholetiket.messages, wholetiket.perusahaan, wholetiket.onepengaduan)
            tempchat.updatemessage({
              id: msg.id,
              kodeunik: generateUniqueId(),
              tiket_id: msg.id,
              sender_id: null,
              message: msg.msg,
              sent_at: datetimenow(),
              gambar_thumb: msg.img,
              gambar: msg.img,
              file: msg.file,
              username: msg.perusahaan.username,
              role_id: 3,
              id_perusahaan: null,
              nama_perusahaan: msg.sender
            })
            this.listchat.insertdata(tempchat)
            console.log(tempchat)
            console.log(msg)
            //console.log(this.listchat.listchatdata)
          }
          //this.addnewmessage(msg)
        } else {
          if (!this.islastpage) {
            if (hasilcektiket.ket == 'listchat') {
              this.listchat.hidetiket(msg.tiket)
            }

            if (hasilcektiket.ket == 'ditandai') {
              inputdatakelistditandai()
            }
          } else {

            if (hasilcektiket.ket == 'both') {
              inputdatakelistchat()
              inputdatakelistditandai()
              currentdatatiket.visible = true
              if (this.currentTiketState.no_tiket == msg.tiket) {
                this.triggerbukachat(currentdatatiket)
              }
              this.listchat.setchattobottom(msg.tiket, hasilcektiket.indextiket['listchat'])
              console.log(currentdatatiket)
              //return
            } else if (hasilcektiket.ket == 'listchat' || hasilcektiket.ket == 'ditandai') {
              wholetiket = msg.wholetiket

              console.log(msg)
              const tiketpilihan = (hasilcektiket.ket == 'listchat') ? this.listchat.listchatdata : this.tiketditandai;
              var temptiket = tiketpilihan[hasilcektiket.indextiket]
              temptiket.visible = true
              temptiket.updatemessage({
                id: msg.id,
                kodeunik: generateUniqueId(),
                tiket_id: msg.id,
                sender_id: null,
                message: msg.msg,
                sent_at: datetimenow(),
                gambar_thumb: msg?.img || msg?.gambar_pengaduan_thumb,
                gambar: msg?.img || msg?.gambar_pengaduan,
                file: msg?.file || msg?.file_pengaduan,
                username: msg.perusahaan.username,
                role_id: 3,
                id_perusahaan: null,
                nama_perusahaan: msg.sender
              })

              if (this.currentTiketState.no_tiket == msg.tiket) {
                this.triggerbukachat(temptiket)
              }

              this.listchat.setchattobottom(msg.tiket, hasilcektiket.indextiket)
            }

          }

          //this.addnewmessage(msg)
        }

        console.log(msg)

      });
    },

    indexofalltiket(notiket) {
      return this.allnotiket.findIndex((e) => {
        return e == notiket;
      });
    },

    setactivepage(n) {
      if (n == "...") {
        return;
      }
      n = Number(n);
      if (n < 1) {
        n = 1;
      }
      if (n > this.maxpage) {
        n = this.maxpage;
      }
      this.currentactivepage = n;
      this.paginatedata.setactivepage(n);


      if (this.searchquery.replaceAll(" ", "") != "") {
        this.carichatfun()
      } else {

        this.prosesdata();
      }
      //console.log(n, this.currentactivepage);
    },
    async getdata(page = 1) {
      return await getInbox(page, this.token);
    },

    async prosesdata() {
      if (this.typebefore == 'cari') {
        this.currentactivepage = 1
        this.typebefore = 'get'
      }
      this.istheredata = false
      this.prevlistchat = [...this.listchat.listchatdata];
      this.listchat.listchatdata = [];
      const datatemp = await this.getdata(this.currentactivepage);
      this.proseshasilget(datatemp)
      this.istheredata = true
    },

    async proseshasilget(datatemp) {
      this.maxdata = await datatemp.tiket.total;
      this.paginatedata.setlengthdata(this.maxdata);

      datatemp.tiket.data.map((item) => {
        var tempchatdata = new Chat(
          item.id,
          item.no_tiket,
          item.status,
          item.messages,
          item.perusahaan,
          item.onepengaduan,
        );

        if (item.perusahaan != null) {
          if (this.listnotiketditandai.includes(item.no_tiket)) {
            tempchatdata.ditandai = true;
          }
          this.listchat.insertdata(tempchatdata);
        }
      });

      this.infopagination = {
        perpage: datatemp.tiket.per_page,
        from: datatemp.tiket.from,
        to: datatemp.tiket.to,
        maxpage: datatemp.tiket.last_page,
        total: datatemp.tiket.total,
      };
    },

    getmessageorfile(data) {
      if (data?.file_pengaduan) {
        return "Mengirim file";
      } else if (data?.gambar_pengaduan) {
        return "Mengirim gambar";
      }

      return data?.message;
    },

    getlastchat(messages) {
      return messages[messages.length - 1];
    },

    fundate(date) {
      return formatChatDate(date);
    },

    updatetandai(activechatparent) {
      if (this.listnotiketditandai.includes(activechatparent.no_tiket)) {
        this.tiketditandai = this.tiketditandai.filter(
          (e) => e.no_tiket !== activechatparent.no_tiket,
        );
      } else {
        this.tiketditandai.push(activechatparent);
      }

      this.listchat.listchatdata = this.listchat.listchatdata.map((item) => {
        if (item.no_tiket == activechatparent.no_tiket) {
          item.ditandai = activechatparent.ditandai;
        }
        return item;
      });

      console.log(activechatparent)
    },

    addnewmessage(msg, sudahrapi = false) {
      const indextiketmasuk = this.indexofalltiket(msg.tiket);

      if (indextiketmasuk != -1) {
        var idxtiket = null
        var tempsetupdata = {}
        if (sudahrapi) {
          tempsetupdata = msg
        } else {
          tempsetupdata = {
            id: msg.id,
            tiket_id: msg.id,
            sender_id: 0,
            message: msg.msg,
            sent_at: msg.dateTime,
            gambar_thumb: msg.img,
            gambar: (msg.img) ? msg.img : msg.gambar_pengaduan,
            file: (msg.file) ? msg.file : msg.file_pengaduan,
            username: msg.sender,
            role_id: 3,
            id_perusahaan: 0,
            user_id: 0,
            nama_perusahaan: msg.sender,
            senderror: false
          }
        }

        var currentdatatiket = null

        const inputdatakelistchat = () => {
          idxtiket = this.listchat.listchatdata.findIndex((e) => {
            return e.no_tiket == msg.tiket;
          });
          currentdatatiket = this.listchat.listchatdata[idxtiket];
          currentdatatiket.updatemessage(tempsetupdata)
          currentdatatiket.visible = false
        }

        const inputdatakelistditandai = () => {
          idxtiket = this.tiketditandai.findIndex((e) => {
            return e.no_tiket == msg.tiket;
          });
          currentdatatiket = this.tiketditandai[idxtiket];
          currentdatatiket.updatemessage(tempsetupdata)
        }

        //console.log('tiket ada dimana : ', this.cektiket(msg.tiket))
        console.log(msg)

        if (this.cektiket(msg.tiket).ket == 'both') {
          //input data ke listchat
          inputdatakelistchat()

          //input data ke list ditandai
          inputdatakelistditandai()
        } else if (this.cektiket(msg.tiket).ket == 'listchat') {
          //input data ke listchat
          inputdatakelistchat()
        } else if (this.cektiket(msg.tiket).ket == 'ditandai') {
          //input data ke list ditandai
          inputdatakelistditandai()
        }

        this.socketio.emit(
          "lockTicket",
          { no_tiket: msg.tiket, username: this.datauser.username },
          (result) => {
            console.log(result);
          }
        )

        if (this.currentTiketState.no_tiket == currentdatatiket.no_tiket) {
          this.triggerbukachat(currentdatatiket)
        }
      }

      return indextiketmasuk;
    },

    triggerbukachat(item) {
      this.socketio.emit(
        "lockTicket",
        { no_tiket: item.no_tiket, username: this.datauser.username },
        (result) => {
          if (result.success == false) {
            Swal.fire({
              title: 'Tidak bisa buka tiket',
              text: result.message,
              icon: 'warning'
            })
            console.log("Tiket sudah dilock")
            return
          } else {
            console.log(result)
            this.$emit('bukachat', item)
          }
          //console.log(result);
        }
      )


    },

    updatepesanerror(notiket, kodeunik) {
      const hasilcektiket = this.cektiket(notiket)

      if (hasilcektiket.indextiket == null) {
        return
      }

      if (hasilcektiket.ket == 'both') {
        var tiketpilihan = [this.listchat.listchatdata[hasilcektiket.indextiket.listchat], this.tiketditandai[hasilcektiket.indextiket.ditandai]]
        tiketpilihan.forEach((tiket) => {
          //console.log(tiket,index)
          const pesan = tiket.messages.find(
            item => item?.kodeunik === kodeunik
          )

          if (pesan) {
            pesan.senderror = true
            tiket.visible = true
          }
        })
      } else {
        const datatikettemp =
          hasilcektiket.ket === 'listchat'
            ? this.listchat.listchatdata
            : this.tiketditandai

        const tiketpilihan = datatikettemp[hasilcektiket.indextiket]

        const pesan = tiketpilihan.messages.find(
          item => item?.kodeunik === kodeunik
        )

        if (pesan) {
          pesan.senderror = true
          tiketpilihan.visible = true
        }
      }
      //this.triggerbukachat(tiketpilihan)
    },

    async closetiket(idtiket, no_tiket) {
      try {
        const res = await axios.post(
          `${backend}/api/tiket/${idtiket}/close`,
          {},
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          },
        );

        if (res.status === 200) {
          this.listchat.removetiket(no_tiket)
          this.$emit('removechat', no_tiket)
          Swal.fire({
            title: "Berhasil Close!",
            text: `Tiket ${no_tiket} sudah berhasil diclose.`,
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: "Gagal Close!",
            text: `${res.data.message}`,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Gagal Close!",
          text: `${error}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }

      // console.log(res)
      // console.log('closetiket : ', idtiket)
    },

    async carichatfun() {
      this.istheredata = false
      this.listchat.listchatdata = []

      if (this.typebefore == 'get' || (this.searchquerybefore != this.searchquery && this.typebefore == 'cari')) {
        this.currentactivepage = 1
        this.typebefore = 'cari'
      }

      if (this.searchquery.replaceAll(" ", "") == "") {
        await this.prosesdata()
        this.currentactivepage = 1
        this.istheredata = true
        return
      }

      const result = await carichat(this.searchquery, this.token, this.currentactivepage)
      if (result?.status === true) {
        const datatemp = result;
        this.proseshasilget(datatemp)
        //this.listchat.listchatdata
      }

      this.istheredata = true
      this.searchquerybefore = this.searchquery

      console.log(this.listchat.listchatdata)
    },

    cektiket(notiket) {
      return cektiket(notiket, this.indexofalltiket(notiket), this.tiketditandai, this.listchat.listchatdata)
    }
  },
};
</script>
<style scoped>
.active {
  background-color: #bad2ff !important;
  color: #095fff;
}

.contain-list {
  width: 430px;
  height: 100%;
  display: grid;
  border-right: 1px solid #dadada;
  border-left: 1px solid #dadada;
  grid-template-rows: max-content auto max-content;
}

.header-list {
  padding: 10px;
  box-sizing: border-box;
  background-color: none;
  padding-bottom: 20px;

  h4 {
    margin-bottom: 10px;
  }

  .pencarian {
    background-color: none;
    width: 100%;
    display: grid;
    grid-template-columns: auto max-content;

    .inputan {
      display: flex;
      align-items: center;

      i {
        color: #9e9e9e;
        margin-left: 10px;
        position: absolute;
      }

      input {
        width: 80%;
        border: 1px solid #9e9e9e;
        border-radius: 8px;
        font-family: poppins-reg;
        font-size: 10pt;
        padding: 7px 35px;
      }

      button {
        padding: 7px 10px;
        font-family: poppins-reg;
        border-radius: 0 8px 8px 0;
        border: 1px solid #9e9e9e;
        background-color: #d1d1d1b7;
      }
    }

    .filter-btn {
      button {
        padding: 9px;
        border-radius: 8px;
        border: 1px solid #9e9e9e;
        background-color: #dddddd;
        color: black;
      }
    }
  }
}

.body-list {
  background-color: none;
  overflow-y: auto;

  h4 {
    color: #095fff;
    background-color: #c8dbff;
    padding: 7px 13px;
    border-radius: 7px;
    width: max-content;
    margin: auto;
    margin-top: 20px;
    font-family: poppins-semi;
    text-align: center;
  }

  h4 i {
    font-size: 20pt;
    transform: translateY(5px);
  }

  .tiket-ditandai {
    border-bottom: 1px solid #9e9e9e;

    h5 {
      margin: 10px;
    }
  }
}

.footer-list {
  background-color: none;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 2px;
    height: 30px;
    width: 30px;
    background-color: rgba(226, 226, 226, 0.712);
    border: 1px solid #c0c0c0;
    border-radius: 5px;
  }

  button:hover {
    background-color: #d1d1d1;
  }
}
</style>
